module.exports = __webpack_public_path__ + "media/images/musician_event-392f4a5f3dccf510aacc0885214fb1c6.png";